var render = function render(){var _vm=this,_c=_vm._self._c;return _c('message-search',{attrs:{"add-and-filter-persmission":_vm.canManageMessage,"default-role":_vm.user.profile.roleid,"delete-message":_vm.deleteMessage,"download-file":_vm.downloadFile,"get-messages":_vm.getMessages}})
}
var staticRenderFns = []

export { render, staticRenderFns }